<div>
    <textarea class="form-control m-b-md"
            name="details"
            [(ngModel)]="details"
            *ngIf="selectedItem.isCanEdit"
            placeholder="Add entry"
            [title]="selectedItem.status != 'closed' ? '' : 'Entries cannot be added to Closed reports'"
            [disabled]="selectedItem.status == 'closed'"
            (change)="entryTyped($event.target.value || !noEntriesEdited())"></textarea>

    <button class="btn btn-default btn-sm font-light"
            (click)="addEntry()"
            *ngIf="selectedItem.isCanEdit"
            [title]="selectedItem.status != 'closed' ? '' : 'Entries cannot be added to Closed reports'"
            [disabled]="!details || disabledEntrySubmit || selectedItem.status == 'closed'">
        Add Comment
    </button>

    <div class="entries-sorting-container m-t-sm">
        <span class="bold">Entries</span>
        <div class="pull-right">
            <span data-toggle="dropdown">
                <span class="bold">Sort By</span>: {{order == 'asc' ? 'Ascending' : 'Descending'}}
                <span class="caret"></span>
            </span>
            <ul class="dropdown-menu">
                <li (click)="sortEntries('asc');">
                    <a>Sort Ascending</a>
                </li>
                <li (click)="sortEntries('desc');">
                    <a>Sort Descending</a>
                </li>
            </ul>
        </div>
    </div>

    <div class="timeline" *ngIf="selectedItem.entries.length > 0">
        <div>
            <ul class="timeline__list">
                <li *ngFor="let e of selectedItem.entries; trackBy: trackByFn; let index = index;">
                    <section>
                        <header class="timeline__header">
                            <span>
                                <time>{{ e.createdAt | date:'yyyy-MM-dd hh:mma' }}</time> - {{ e.createdBy ? e.createdBy.fullName : '-' }}
                            </span>
                        </header>

                        <main class="timeline__content">
                            <div>
                                {{ e.dateTo | date:'yyyy-MM-dd hh:mma'}}
                            </div>
                            <div>
                                <div class="dv-value" *ngIf="!e.editMode">
                                    <pre>{{e.details}}</pre>
                                    <i *ngIf="selectedItem.status === 'draft' && selectedItem.isCanEdit"
                                    class="fa fa-pencil pull-right"
                                    (click)="e.editMode = true"
                                    data-toggle="tooltip" data-placement="top" title="Edit"></i>
                                    <i *ngIf="selectedItem.status === 'draft' && selectedItem.isCanEdit"
                                    (click)="removeEntry(index)"
                                    class="fa fa-trash pull-right"
                                    title="Delete"></i>
                                </div>
                                <div class="dv-value-edit m-t-sm" *ngIf="e.editMode">
                                    <textarea class="form-control"
                                            name="entry{{index}}"
                                            id="entry{{index}}"
                                            [ngModel]="e.details"
                                            required
                                            (change)="entryTyped($event.target.value != e.details || details)"
                                            maxlength="255"
                                            (keyup.enter)="editEntry(index)"></textarea>
                                    <button type="button" (click)="editEntry(index)" [disabled]="disabledEntrySubmit">
                                        <i class="fa fa-check"></i>
                                    </button>
                                    <button type="button"
                                            (click)="closeEntryEditing(e, index)"
                                            [disabled]="disabledEntrySubmit">
                                        <i class="fa fa-times"></i>
                                    </button>
                                </div>
                            </div>
                        </main>
                    </section>
                </li>
            </ul>
        </div>
    </div>
    <spinner [spinnerShow]="commentsLoading"></spinner>
</div>


// WEBPACK FOOTER //
// /app/src/app/views/incident-reports/incident-report-detailed-view/incident-reports-comments/incident-reports-comments.component.html